export const URL_BACKEND =
  typeof localStorage !== "undefined" &&
  process.env.REACT_APP_MUTABLE === "true"
    ? (localStorage.getItem("hallow_test_api") ??
      process.env.DOPPLER_PUBLIC_BACKEND_URL)
    : process.env.DOPPLER_PUBLIC_BACKEND_URL;
